<template>
  <div class="iframe-container">
    <iframe
      :src="iframeUrl"
      class="fullscreen-iframe"
      frameborder="0"
      allowfullscreen
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'BlogView',
  data() {
    return {
      iframeUrl: 'https://zast-ai.github.io/blog/',
    };
  },
};
</script>

<style scoped>
.iframe-container {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
}

.fullscreen-iframe {
  width: 100%;
  height: 100%;
  border: none;
}
</style>